import { Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { Button, Flex, Input, Typography } from '../common';
import { RESET_PASSWORD_FORM_FIELDS, TYPOGRAPHY } from '../../constants';
import { useForm } from 'antd/es/form/Form';
import { useNavigate } from 'react-router-dom';
import { useThemeContext } from '../../theme/GlobalTheme';
import { getUser } from '../../api/user';
import { showMessage } from '../common/Message';
import { resetPassword } from '../../api';

function PasswordManagement() {
  const navigate = useNavigate();
  const { isDark } = useThemeContext();
  const {
    CURRENT_PASSWORD_FIELD,
    NEW_PASSWORD_FIELD,
    CONFIRM_NEW_PASSWORD_FIELD,
  } = RESET_PASSWORD_FORM_FIELDS;
  const [emailId, setEmailId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form] = useForm();

  useEffect(() => {
    async function getUserData() {
      const response = await getUser();
      setEmailId(response.data.data[0].emailId);
    }
    getUserData();
  }, []);

  const handleReset = async () => {
    try {
      setLoading(true);
      const formValues = await form.validateFields();

      if (formValues.newPassword !== formValues.confirmNewPassword) {
        showMessage({ type: 'warning', content: 'Please match passwords' });
        setLoading(false);
        return;
      }

      const response = await resetPassword({
        emailId,
        newPassword: formValues.newPassword,
        currentPassword: formValues.currentPassword,
      });

      if (response.data.status === 200 && response.data.code === 1) {
        showMessage({ type: 'success', content: response.data.message });
        setTimeout(() => {
          navigate('/auth/login');
        }, 3000);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <Form
        form={form}
        className=" flex flex-col h-full min-h-[calc(100vh-12rem)] justify-between"
      >
        <Flex vertical gap={20} className="p-4">
          <Typography text="Password Management" type={TYPOGRAPHY.TITLE} />
          <Flex vertical justify="center" className="!max-w-96" gap={8}>
            <Form.Item className="!m-0" name="currentPassword">
              <Input {...CURRENT_PASSWORD_FIELD} />
            </Form.Item>

            <Form.Item className="!m-0" name="newPassword">
              <Input {...NEW_PASSWORD_FIELD} />
            </Form.Item>

            <Form.Item
              className="!m-0"
              name="confirmNewPassword"
              dependencies={['newPassword']}
            >
              <Input {...CONFIRM_NEW_PASSWORD_FIELD} />
            </Form.Item>
          </Flex>
        </Flex>
        <Flex vertical justify="space-between" className="w-full text-white">
          <Flex
            justify="end"
            className={`sticky bottom-0 w-full lg:justify-between justify-end p-4 border-t h-[56px] md:h-[72px] border-[#7C30F7] ${
              isDark ? 'bg-primaryDark' : 'bg-primaryLight'
            } `}
          >
            <Button
              text="Back"
              onClick={() => {
                navigate(-1);
              }}
              buttonProps={{ type: 'primary-none' }}
            />
            <Button
              onClick={handleReset}
              text="Save"
              loadingData={loading}
              buttonProps={{ type: 'primary-square' }}
            />
          </Flex>
        </Flex>
      </Form>
    </>
  );
}

export default PasswordManagement;
